import { closeMobileMenu } from './nav.js';

export const keyboard = function () {
	document.addEventListener('keyup', (event) => {
		if (event.keyCode === 27) {
			closeMobileMenu();
		}
	});
};
